"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: common/limit-error.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcommon%2Flimit-error.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.limitErrorIdToJSON = exports.limitErrorIdFromJSON = exports.LimitErrorId = void 0;
/* eslint-disable */
const protobufPackage = 'com.step.common.limit.proto';
var LimitErrorId;
(function (LimitErrorId) {
    LimitErrorId["INVALID_LIMIT_ID"] = "INVALID_LIMIT_ID";
    LimitErrorId["ACH_IN_FUNDING_DAILY"] = "ACH_IN_FUNDING_DAILY";
    LimitErrorId["ACH_IN_FUNDING_MONTHLY"] = "ACH_IN_FUNDING_MONTHLY";
    LimitErrorId["ACH_IN_WITHDRAWAL_DAILY"] = "ACH_IN_WITHDRAWAL_DAILY";
    LimitErrorId["ACH_IN_WITHDRAWAL_MONTHLY"] = "ACH_IN_WITHDRAWAL_MONTHLY";
    LimitErrorId["ACH_OUT_FUNDING_DAILY"] = "ACH_OUT_FUNDING_DAILY";
    LimitErrorId["ACH_OUT_FUNDING_WEEKLY"] = "ACH_OUT_FUNDING_WEEKLY";
    LimitErrorId["ACH_OUT_FUNDING_MONTHLY"] = "ACH_OUT_FUNDING_MONTHLY";
    LimitErrorId["ACH_OUT_WITHDRAWAL_DAILY"] = "ACH_OUT_WITHDRAWAL_DAILY";
    LimitErrorId["ACH_OUT_WITHDRAWAL_WEEKLY"] = "ACH_OUT_WITHDRAWAL_WEEKLY";
    LimitErrorId["ACH_OUT_WITHDRAWAL_MONTHLY"] = "ACH_OUT_WITHDRAWAL_MONTHLY";
    LimitErrorId["ALL_P2P_DAILY"] = "ALL_P2P_DAILY";
    LimitErrorId["ALL_P2P_MONTHLY"] = "ALL_P2P_MONTHLY";
    LimitErrorId["ATM_DAILY"] = "ATM_DAILY";
    LimitErrorId["ATM_MONTHLY"] = "ATM_MONTHLY";
    LimitErrorId["CASH_BACK_DAILY"] = "CASH_BACK_DAILY";
    LimitErrorId["CASH_DEPOSIT_TRANSACTION"] = "CASH_DEPOSIT_TRANSACTION";
    LimitErrorId["CASH_DEPOSIT_DAILY"] = "CASH_DEPOSIT_DAILY";
    LimitErrorId["CASH_DEPOSIT_WEEKLY"] = "CASH_DEPOSIT_WEEKLY";
    LimitErrorId["CASH_DEPOSIT_MONTHLY"] = "CASH_DEPOSIT_MONTHLY";
    LimitErrorId["CARD_TRANSACTIONS_TRANSACTION"] = "CARD_TRANSACTIONS_TRANSACTION";
    LimitErrorId["CARD_TRANSACTIONS_DAILY"] = "CARD_TRANSACTIONS_DAILY";
    LimitErrorId["CARD_TRANSACTIONS_WEEKLY"] = "CARD_TRANSACTIONS_WEEKLY";
    LimitErrorId["CARD_TRANSACTIONS_MONTHLY"] = "CARD_TRANSACTIONS_MONTHLY";
    LimitErrorId["CHECK_DEPOSIT_TRANSACTION"] = "CHECK_DEPOSIT_TRANSACTION";
    LimitErrorId["CHECK_DEPOSIT_MONTHLY"] = "CHECK_DEPOSIT_MONTHLY";
    LimitErrorId["CARD_PAYOUT_DAILY"] = "CARD_PAYOUT_DAILY";
    LimitErrorId["CARD_PAYOUT_MONTHLY"] = "CARD_PAYOUT_MONTHLY";
    LimitErrorId["CARD_OTC_WITHDRAWAL_DAILY"] = "CARD_OTC_WITHDRAWAL_DAILY";
    LimitErrorId["SEND_P2P_DAILY"] = "SEND_P2P_DAILY";
    LimitErrorId["SEND_P2P_MONTHLY"] = "SEND_P2P_MONTHLY";
    LimitErrorId["CARD_FUNDING_DAILY"] = "CARD_FUNDING_DAILY";
    LimitErrorId["CARD_FUNDING_WEEKLY"] = "CARD_FUNDING_WEEKLY";
    LimitErrorId["CARD_FUNDING_MONTHLY"] = "CARD_FUNDING_MONTHLY";
    LimitErrorId["CRYPTO_BUY_WEEKLY"] = "CRYPTO_BUY_WEEKLY";
    LimitErrorId["STOCK_BUY_WEEKLY"] = "STOCK_BUY_WEEKLY";
    LimitErrorId["WALLET_CARD_TRANSACTIONS_DAILY"] = "WALLET_CARD_TRANSACTIONS_DAILY";
    LimitErrorId["NON_WALLET_CARD_TRANSACTIONS_DAILY"] = "NON_WALLET_CARD_TRANSACTIONS_DAILY";
    LimitErrorId["UDL_CRYPTO_BUY_WEEKLY"] = "UDL_CRYPTO_BUY_WEEKLY";
    LimitErrorId["UNAUTHENTICATED_CARD_FUNDING_DAILY"] = "UNAUTHENTICATED_CARD_FUNDING_DAILY";
    LimitErrorId["UNAUTHENTICATED_CARD_FUNDING_MONTHLY"] = "UNAUTHENTICATED_CARD_FUNDING_MONTHLY";
    LimitErrorId["UNRECOGNIZED"] = "UNRECOGNIZED";
})(LimitErrorId || (exports.LimitErrorId = LimitErrorId = {}));
function limitErrorIdFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_LIMIT_ID':
            return LimitErrorId.INVALID_LIMIT_ID;
        case 1:
        case 'ACH_IN_FUNDING_DAILY':
            return LimitErrorId.ACH_IN_FUNDING_DAILY;
        case 2:
        case 'ACH_IN_FUNDING_MONTHLY':
            return LimitErrorId.ACH_IN_FUNDING_MONTHLY;
        case 3:
        case 'ACH_IN_WITHDRAWAL_DAILY':
            return LimitErrorId.ACH_IN_WITHDRAWAL_DAILY;
        case 4:
        case 'ACH_IN_WITHDRAWAL_MONTHLY':
            return LimitErrorId.ACH_IN_WITHDRAWAL_MONTHLY;
        case 5:
        case 'ACH_OUT_FUNDING_DAILY':
            return LimitErrorId.ACH_OUT_FUNDING_DAILY;
        case 6:
        case 'ACH_OUT_FUNDING_WEEKLY':
            return LimitErrorId.ACH_OUT_FUNDING_WEEKLY;
        case 7:
        case 'ACH_OUT_FUNDING_MONTHLY':
            return LimitErrorId.ACH_OUT_FUNDING_MONTHLY;
        case 8:
        case 'ACH_OUT_WITHDRAWAL_DAILY':
            return LimitErrorId.ACH_OUT_WITHDRAWAL_DAILY;
        case 9:
        case 'ACH_OUT_WITHDRAWAL_WEEKLY':
            return LimitErrorId.ACH_OUT_WITHDRAWAL_WEEKLY;
        case 10:
        case 'ACH_OUT_WITHDRAWAL_MONTHLY':
            return LimitErrorId.ACH_OUT_WITHDRAWAL_MONTHLY;
        case 11:
        case 'ALL_P2P_DAILY':
            return LimitErrorId.ALL_P2P_DAILY;
        case 12:
        case 'ALL_P2P_MONTHLY':
            return LimitErrorId.ALL_P2P_MONTHLY;
        case 13:
        case 'ATM_DAILY':
            return LimitErrorId.ATM_DAILY;
        case 14:
        case 'ATM_MONTHLY':
            return LimitErrorId.ATM_MONTHLY;
        case 15:
        case 'CASH_BACK_DAILY':
            return LimitErrorId.CASH_BACK_DAILY;
        case 16:
        case 'CASH_DEPOSIT_TRANSACTION':
            return LimitErrorId.CASH_DEPOSIT_TRANSACTION;
        case 17:
        case 'CASH_DEPOSIT_DAILY':
            return LimitErrorId.CASH_DEPOSIT_DAILY;
        case 18:
        case 'CASH_DEPOSIT_WEEKLY':
            return LimitErrorId.CASH_DEPOSIT_WEEKLY;
        case 19:
        case 'CASH_DEPOSIT_MONTHLY':
            return LimitErrorId.CASH_DEPOSIT_MONTHLY;
        case 20:
        case 'CARD_TRANSACTIONS_TRANSACTION':
            return LimitErrorId.CARD_TRANSACTIONS_TRANSACTION;
        case 21:
        case 'CARD_TRANSACTIONS_DAILY':
            return LimitErrorId.CARD_TRANSACTIONS_DAILY;
        case 22:
        case 'CARD_TRANSACTIONS_WEEKLY':
            return LimitErrorId.CARD_TRANSACTIONS_WEEKLY;
        case 23:
        case 'CARD_TRANSACTIONS_MONTHLY':
            return LimitErrorId.CARD_TRANSACTIONS_MONTHLY;
        case 24:
        case 'CHECK_DEPOSIT_TRANSACTION':
            return LimitErrorId.CHECK_DEPOSIT_TRANSACTION;
        case 25:
        case 'CHECK_DEPOSIT_MONTHLY':
            return LimitErrorId.CHECK_DEPOSIT_MONTHLY;
        case 26:
        case 'CARD_PAYOUT_DAILY':
            return LimitErrorId.CARD_PAYOUT_DAILY;
        case 27:
        case 'CARD_PAYOUT_MONTHLY':
            return LimitErrorId.CARD_PAYOUT_MONTHLY;
        case 28:
        case 'CARD_OTC_WITHDRAWAL_DAILY':
            return LimitErrorId.CARD_OTC_WITHDRAWAL_DAILY;
        case 29:
        case 'SEND_P2P_DAILY':
            return LimitErrorId.SEND_P2P_DAILY;
        case 30:
        case 'SEND_P2P_MONTHLY':
            return LimitErrorId.SEND_P2P_MONTHLY;
        case 31:
        case 'CARD_FUNDING_DAILY':
            return LimitErrorId.CARD_FUNDING_DAILY;
        case 32:
        case 'CARD_FUNDING_WEEKLY':
            return LimitErrorId.CARD_FUNDING_WEEKLY;
        case 33:
        case 'CARD_FUNDING_MONTHLY':
            return LimitErrorId.CARD_FUNDING_MONTHLY;
        case 34:
        case 'CRYPTO_BUY_WEEKLY':
            return LimitErrorId.CRYPTO_BUY_WEEKLY;
        case 35:
        case 'STOCK_BUY_WEEKLY':
            return LimitErrorId.STOCK_BUY_WEEKLY;
        case 36:
        case 'WALLET_CARD_TRANSACTIONS_DAILY':
            return LimitErrorId.WALLET_CARD_TRANSACTIONS_DAILY;
        case 37:
        case 'NON_WALLET_CARD_TRANSACTIONS_DAILY':
            return LimitErrorId.NON_WALLET_CARD_TRANSACTIONS_DAILY;
        case 38:
        case 'UDL_CRYPTO_BUY_WEEKLY':
            return LimitErrorId.UDL_CRYPTO_BUY_WEEKLY;
        case 39:
        case 'UNAUTHENTICATED_CARD_FUNDING_DAILY':
            return LimitErrorId.UNAUTHENTICATED_CARD_FUNDING_DAILY;
        case 40:
        case 'UNAUTHENTICATED_CARD_FUNDING_MONTHLY':
            return LimitErrorId.UNAUTHENTICATED_CARD_FUNDING_MONTHLY;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return LimitErrorId.UNRECOGNIZED;
    }
}
exports.limitErrorIdFromJSON = limitErrorIdFromJSON;
function limitErrorIdToJSON(object) {
    switch (object) {
        case LimitErrorId.INVALID_LIMIT_ID:
            return 'INVALID_LIMIT_ID';
        case LimitErrorId.ACH_IN_FUNDING_DAILY:
            return 'ACH_IN_FUNDING_DAILY';
        case LimitErrorId.ACH_IN_FUNDING_MONTHLY:
            return 'ACH_IN_FUNDING_MONTHLY';
        case LimitErrorId.ACH_IN_WITHDRAWAL_DAILY:
            return 'ACH_IN_WITHDRAWAL_DAILY';
        case LimitErrorId.ACH_IN_WITHDRAWAL_MONTHLY:
            return 'ACH_IN_WITHDRAWAL_MONTHLY';
        case LimitErrorId.ACH_OUT_FUNDING_DAILY:
            return 'ACH_OUT_FUNDING_DAILY';
        case LimitErrorId.ACH_OUT_FUNDING_WEEKLY:
            return 'ACH_OUT_FUNDING_WEEKLY';
        case LimitErrorId.ACH_OUT_FUNDING_MONTHLY:
            return 'ACH_OUT_FUNDING_MONTHLY';
        case LimitErrorId.ACH_OUT_WITHDRAWAL_DAILY:
            return 'ACH_OUT_WITHDRAWAL_DAILY';
        case LimitErrorId.ACH_OUT_WITHDRAWAL_WEEKLY:
            return 'ACH_OUT_WITHDRAWAL_WEEKLY';
        case LimitErrorId.ACH_OUT_WITHDRAWAL_MONTHLY:
            return 'ACH_OUT_WITHDRAWAL_MONTHLY';
        case LimitErrorId.ALL_P2P_DAILY:
            return 'ALL_P2P_DAILY';
        case LimitErrorId.ALL_P2P_MONTHLY:
            return 'ALL_P2P_MONTHLY';
        case LimitErrorId.ATM_DAILY:
            return 'ATM_DAILY';
        case LimitErrorId.ATM_MONTHLY:
            return 'ATM_MONTHLY';
        case LimitErrorId.CASH_BACK_DAILY:
            return 'CASH_BACK_DAILY';
        case LimitErrorId.CASH_DEPOSIT_TRANSACTION:
            return 'CASH_DEPOSIT_TRANSACTION';
        case LimitErrorId.CASH_DEPOSIT_DAILY:
            return 'CASH_DEPOSIT_DAILY';
        case LimitErrorId.CASH_DEPOSIT_WEEKLY:
            return 'CASH_DEPOSIT_WEEKLY';
        case LimitErrorId.CASH_DEPOSIT_MONTHLY:
            return 'CASH_DEPOSIT_MONTHLY';
        case LimitErrorId.CARD_TRANSACTIONS_TRANSACTION:
            return 'CARD_TRANSACTIONS_TRANSACTION';
        case LimitErrorId.CARD_TRANSACTIONS_DAILY:
            return 'CARD_TRANSACTIONS_DAILY';
        case LimitErrorId.CARD_TRANSACTIONS_WEEKLY:
            return 'CARD_TRANSACTIONS_WEEKLY';
        case LimitErrorId.CARD_TRANSACTIONS_MONTHLY:
            return 'CARD_TRANSACTIONS_MONTHLY';
        case LimitErrorId.CHECK_DEPOSIT_TRANSACTION:
            return 'CHECK_DEPOSIT_TRANSACTION';
        case LimitErrorId.CHECK_DEPOSIT_MONTHLY:
            return 'CHECK_DEPOSIT_MONTHLY';
        case LimitErrorId.CARD_PAYOUT_DAILY:
            return 'CARD_PAYOUT_DAILY';
        case LimitErrorId.CARD_PAYOUT_MONTHLY:
            return 'CARD_PAYOUT_MONTHLY';
        case LimitErrorId.CARD_OTC_WITHDRAWAL_DAILY:
            return 'CARD_OTC_WITHDRAWAL_DAILY';
        case LimitErrorId.SEND_P2P_DAILY:
            return 'SEND_P2P_DAILY';
        case LimitErrorId.SEND_P2P_MONTHLY:
            return 'SEND_P2P_MONTHLY';
        case LimitErrorId.CARD_FUNDING_DAILY:
            return 'CARD_FUNDING_DAILY';
        case LimitErrorId.CARD_FUNDING_WEEKLY:
            return 'CARD_FUNDING_WEEKLY';
        case LimitErrorId.CARD_FUNDING_MONTHLY:
            return 'CARD_FUNDING_MONTHLY';
        case LimitErrorId.CRYPTO_BUY_WEEKLY:
            return 'CRYPTO_BUY_WEEKLY';
        case LimitErrorId.STOCK_BUY_WEEKLY:
            return 'STOCK_BUY_WEEKLY';
        case LimitErrorId.WALLET_CARD_TRANSACTIONS_DAILY:
            return 'WALLET_CARD_TRANSACTIONS_DAILY';
        case LimitErrorId.NON_WALLET_CARD_TRANSACTIONS_DAILY:
            return 'NON_WALLET_CARD_TRANSACTIONS_DAILY';
        case LimitErrorId.UDL_CRYPTO_BUY_WEEKLY:
            return 'UDL_CRYPTO_BUY_WEEKLY';
        case LimitErrorId.UNAUTHENTICATED_CARD_FUNDING_DAILY:
            return 'UNAUTHENTICATED_CARD_FUNDING_DAILY';
        case LimitErrorId.UNAUTHENTICATED_CARD_FUNDING_MONTHLY:
            return 'UNAUTHENTICATED_CARD_FUNDING_MONTHLY';
        case LimitErrorId.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.limitErrorIdToJSON = limitErrorIdToJSON;
//# sourceMappingURL=limit-error.js.map